import { create } from "zustand";

export const useModalStore = create((set, get) => ({
  modals: [],
  openModal: (component, props = {}, options = {}) =>
    new Promise((resolve) => {
      const id = `msg-${Date.now()}-${Math.random()}`;
      set((state) => ({
        modals: [...state.modals, { id, component, props, resolve, options }],
      }));
    }),
  closeModal: (result) => {
    const { modals } = get();
    const last = modals[modals.length - 1];
    if (last) last.resolve(result);
    set({ modals: modals.slice(0, -1) });
  },
}));
